import { Form, Input, Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import {
    ProductsFilter,
    ProductsStore,
} from 'src/stores/ProductsStore/ProductsStore';
import { FormHelper } from 'src/utils/FormHelper';
import styled from 'styled-components';

export const ProductsHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper data-testid="products-list-header-wrapper">
            <SearchPanel
                inputSearchFormName={formNames.getPath('filterSearch')}
                store={store}
                renderPanel={(props) => <FilterPanel {...props} />}
                inputSearchPlaceholder={t(
                    'Page.Products.AsideHeader.Search.Placeholder',
                )}
            />
        </StyledHeaderWrapper>
    );
});

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;

const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={(values: ProductsFilter) => {
                store.pager.reset();
                store.filterCriteria?.applyFilter(
                    convertFormValuesToFilterCriteria(values),
                );
                store.loadList();
            }}
        >
            <StyledSelect
                label={t('Page.Products.Filter.Status')}
                name={formNames.getPath('filterActive')}
            >
                <Select allowClear data-testid="filterActive">
                    <Select.Option value="true" data-testid="true">
                        {t(`data:status.product.ACTIVE`)}
                    </Select.Option>
                    <Select.Option value="false" data-testid="false">
                        {t(`data:status.product.INACTIVE`)}
                    </Select.Option>
                </Select>
            </StyledSelect>
            <Form.Item
                label={t('Page.Products.Filter.MaxAmount')}
                name={formNames.getPath('filterAmount')}
            >
                <StyledInput type="number" data-testid="filterAmount" />
            </Form.Item>
            <Form.Item
                label={t('Page.Products.Filter.MaxTerm')}
                name={formNames.getPath('filterTerm')}
            >
                <StyledInput type="number" data-testid="filterTerm" />
            </Form.Item>
        </SearchPanelFilterForm>
    );
});

const store = ProductsStore;
const formNames = FormHelper.createNameProvider<ProductsFilter>();

const convertFormValuesToFilterCriteria = (
    values: ProductsFilter,
): ProductsFilter => {
    return values;
};

const StyledSelect = styled(Form.Item)`
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        display: flex;
        align-items: center;
        height: 2.7rem;
        border-radius: 0.5rem;
    }
`;

const StyledInput = styled(Input)`
    height: 2.7rem;
    border-radius: 0.5rem;
`;
